import React, { useState, useEffect } from "react";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import { Col, InputGroup, Button, Row, Spinner, Accordion, Card } from "react-bootstrap";
import _ from "lodash";
import { FormProvider, useForm, Controller } from "react-hook-form";
import AddFaqModal from "./AddFaqModal";
import ApiPageContent from "../../../core/api/api.pageContent";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import DataGrid from "./DataGrid";
import { tools } from "../../../core/utils/tools";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import GlobalFormControl from "../_Components/GlobalFormControl";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiRegion from "../../../core/api/api.region";
import ApiAmusementGroup from "../../../core/api/api.amusementGroup";
import ApiHome from "../../../core/api/api.home";

const PageContent = () => {
  const [showFaqModal, setShowFaqModal] = useState(false);
  const [types, setTypes] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const [listData, setListData] = useState({});
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
  const [allAmusementCityList, setAllAmusementCityList] = useState([]);
  const [allAmusementGroupList, setAllAmusementGroupList] = useState([]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});

  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };

  useEffect(() => {
    (async () => {
      try {
        const data = await ApiPageContent.getAllPageContent({
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
          globalSearch: searchParams.get("globalSearch"),
          cityId: searchParams.get("cityId"),
          groupId: searchParams.get("groupId"),
          pageType: searchParams.get("pageType"),
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
        //لیست شهرها
        const allAmusementCityList = await ApiRegion.getAllCity();
        setAllAmusementCityList(allAmusementCityList.map((item) => ({
          value: item.id,
          label: item.id + "-" + item.name,
        })));
        // لیست دسته های تفریحی
        const allAmusmentGroupList = (await ApiAmusementGroup.getAllGroups())
        setAllAmusementGroupList(allAmusmentGroupList)
        const types = await ApiHome.getEnums({ enumName: "PageType" });
        setTypes(types.data);
        const formInputs = [
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
          {
            name: "cityId",
            type: "multiSelect",
            isMulti: false,
            data: allAmusementCityList.map((item) => ({
              value: item.id,
              label: item.id + "-" + item.name,
            })),
          },
          {
            name: "groupId",
            type: "multiSelect",
            isMulti: false,
            data: allAmusmentGroupList?.map((item) => ({
              value: item.id,
              label: item.title,
            })),
          },
          {
            name: "pageType",
            type: "multiSelect",
            isMulti: false,
            data: types.data?.map((item) => ({
              value: item.id,
              label: item.title,
            })),
          },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);

      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  const onSubmit = async (data) => {
    // data.cityId = data.cityId?.map(ci => ci.value).join(",")
    data.cityId = data.cityId?.value
    data.groupId = data.groupId?.value
    data.pageType = data.pageType?.value
    tools.setPageNumber(data, searchParams, setValue);
    const apiData = await ApiPageContent.getAllPageContent(data);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/pageContent?${queryString}`);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">محتوای صفحات</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست محتوای صفحات</span>
          </h3>
          <div className="card-toolbar">
            <Link className="btn btn-primary" to="/pageContent/0">
              <AddCircle className="mr-1" />
              ایجاد محتوای صفحات
            </Link>
          </div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              <div className="border-top">
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 text-gray fs-normal">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body>
                        <Row>
                          <Col sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="pageType"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-2"
                                  placeholder="نوع"
                                  options={types.filter(item => (!!watch("cityId") || !!watch("groupId")) ? item.title == "دسته بندی" : true).map((item) => ({
                                    value: item.id,
                                    label: item.title,
                                  }))}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="cityId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-2"
                                  placeholder="شهر"
                                  options={allAmusementCityList}
                                  field={field}
                                  onChange={field.onChange}
                                  isDisabled={watch("pageType") && watch("pageType").label != "دسته بندی"}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="groupId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={allAmusementGroupList?.map((item) => ({
                                    value: item.id,
                                    label: item.title,
                                  }))}
                                  placeholder="دسته تفریحی"
                                  className=" mt-2"
                                  field={field}
                                  isDisabled={watch("pageType") && watch("pageType").label != "دسته بندی"}
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className="tb-reponsive px-2 mt-3 mt-xl-0 mx-auto">
                            <Button variant="success" type="submit" disabled={isSubmitting} className=" mt-3">
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>
              <div className="">
                {/* table */}
                <Col xs="12" className="tb-reponsive px-0">
                  <DataGrid data={listData} />
                </Col>
              </div>
            </form>
          </FormProvider>
          {showFaqModal && <AddFaqModal showFaqModal={showFaqModal} setShowFaqModal={setShowFaqModal} />}
        </div>
      </div>
    </div>
  );
};

export default PageContent;
